/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ChatConversationRequest {
    getFixupPrototypeFunction() { return ChatConversationRequest.fixupPrototype; }

    static newInstance(model: Partial<ChatConversationRequest>): ChatConversationRequest {
        let obj = Object.assign(new ChatConversationRequest(), model);
        ChatConversationRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ChatConversationRequest>): ChatConversationRequest {
        if (!model) return null;
        return ChatConversationRequest.newInstance(<ChatConversationRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ChatConversationRequest) {
        if (!obj) return;

        models.ChatConversationRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ChatConversationRequest): boolean {
        Object.setPrototypeOf(obj, ChatConversationRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.ChatConversationFilter.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.ChatConversationSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.ChatConversationSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.ChatConversationFilter;

}
